import { MAX_APY, MIN_TVL, VAULTS_PER_PAGE } from '@/config/query/allVaults'
import type { SdkNetwork } from '@/types/network'

export const MINIMUM_BALANCE_THRESHOLD = 1 // 1 USD to avoid dust options
export const MAX_VAULTS_PER_ASSET = 2
export const MINIMUM_VAULT_TVL = 5_000_000
export const BIGGER_VAULT_TVL = 50_000_000
export const MINIMUM_POSITIONS_VAULT_TVL = 1_000
export const MIN_VAULT_SCORE = 80
export const DEFAULT_HISTORICAL_GRANULARITY = '1day'

export const ALL_SDK_NETWORKS = [
  'mainnet',
  'optimism',
  'arbitrum',
  'polygon',
  'gnosis',
  'base',
  'unichain',
  'swellchain',
  'celo',
  'worldchain',
  'berachain',
  'ink',
  'bsc',
  'hyperliquid',
  'plasma',
  'avalanche',
  'katana',
  'linea',
  'mega-eth',
  'monad',
  'etherlink',
  'robinhood',
] as const satisfies SdkNetwork[]

export const allVaultsQueryParams = {
  page: 0,
  perPage: VAULTS_PER_PAGE,
  onlyAppFeatured: true,
  onlyTransactional: false,
  minTvl: MIN_TVL,
  maxApy: MAX_APY,
  allowedNetworks: ALL_SDK_NETWORKS,
}

export const borrowMarketsQueryParams = {
  minTvl: MIN_TVL,
}

export const BEST_PERFORMING_VAULTS_MIN_TVL = 10_000_000
